export const TO_ACCEPT = 'ACEPTAR'
export const TRY_AGAIN = 'PROBAR DE NUEVO'
